import React, { useEffect } from 'react';
import { ThemeProvider } from '@vmos2/themes';
import { useGoogleTagManager, useHybridApp, useRoute } from '@vmos2/utils';
import {
  AccessibilityProvider,
  ConfigProvider,
  DeviceSizeProvider,
  LoyaltyProvider,
  ToastProvider,
  UserProvider,
  useSettings,
} from '@vmos2/providers';
import { APP_CONFIG } from '@vmos2/core';
import { LocationProvider } from '@vmos2/location';
import { OfflineWrapper } from '@vmos2/cordova';

type Props = {
  bootstrap: {
    settings: {},
    tenant: {},
    theme: {
      payload: {},
    },
  },
};

const App = ({ bootstrap }: Props): React$Node => {
  const { tenant, theme } = bootstrap;
  const { getRouteComponent } = useRoute();
  const settings = useSettings();
  const { mobilePushNotificationsEnabled } = settings;
  const { enablePushNotifications } = useHybridApp();
  const { initializeGTM } = useGoogleTagManager(settings);

  const routes = getRouteComponent();

  useEffect(() => {
    enablePushNotifications(mobilePushNotificationsEnabled);
  }, [enablePushNotifications, mobilePushNotificationsEnabled]);

  useEffect(() => {
    initializeGTM();
  }, [initializeGTM]);

  return (
    <ThemeProvider theme={theme?.payload} tenant={tenant}>
      <ConfigProvider {...APP_CONFIG} bootstrap={bootstrap}>
        <ToastProvider>
          <UserProvider>
            <DeviceSizeProvider>
              <LoyaltyProvider>
                <AccessibilityProvider>
                  <OfflineWrapper>
                    <LocationProvider settings={bootstrap.settings}>{routes}</LocationProvider>
                  </OfflineWrapper>
                </AccessibilityProvider>
              </LoyaltyProvider>
            </DeviceSizeProvider>
          </UserProvider>
        </ToastProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;
